import { QueryString } from '../functions';

const giftBoxesModule = {
    isLoading: false,
    init() {
        $(document).on('click', '.gift-box-remove-message-btn', this, this.removeMessage);
        $(document).on('click', '#gift_box_add_message_btn', this, this.addMessage);
        $(document).on('change', '#sort', this, this.sort);
        $(document).on('change', '#category', this, this.category);
        $(document).on('change', '.gift-box-cart-qty', this, this.changeQty);
        $(document).on('click', '.gift-box-add-to-cart-btn', this, this.addToBox);
        $(document).on('click', '.gift-box-remove-from-cart-btn', this, this.removeFromBox);
        $(document).on('click', '.box-item-quantity-minus', this, this.changeQty);
        $(document).on('click', '.box-item-quantity-plus', this, this.changeQty);
        $(document).on('click', '.bift-boxes-select-box-btn', this, this.selectBox);
    },
    selectBox(event) {
        const _this = event.data;
        var element = this;
        var activeSlide = $('.swiper-slide.swiper-slide-active');
        if (activeSlide.length > 0) {
            window.location = $(activeSlide).data('url');
        }
    },
    removeMessage(event) {
        const _this = event.data;
        var element = this;
        var url = $(this).data('url');

        if (_this.isLoading) { return false; }

        _this.isLoading = true;

        var values = '_token=' + $("meta[name='csrf-token']").attr("content");;
		$.ajax({
            type: "POST",
            url: baseURL + "/gift-box/remove-message",
            data: values,
            success: function(response) {
				_this.isLoading = false;

                if (response.status == 1) {

                    window.location = url;

                    $('#mobile-gift-box-cart-container').html(response.mobile_view);
					$('#gift-box-cart-container').html(response.view);
                    const ps = new
                        PerfectScrollbar('.scroll-box', {
                        wheelSpeed: 2,
                        // wheelPropagation: true,
                        minScrollbarLength: 20,
                        // maxScrollbarLength: 63,
                        useBothWheelAxes: true
                    });

					return;
                }

				Swal.fire({
					width: "350px",
					//icon: "success",
					title: "Error!",
					html: response.message
				});
            },
            error(error) {
				_this.isLoading = false;
            }
        });
    },
    addMessage(event) {
        const _this = event.data;
        var element = this;
        var url = $(this).data('url');

        if (_this.isLoading) { return false; }

        var errors = false;
        $('.gift_box_message_form').find('.form-control').removeClass('is-invalid');
        if ($('#gift_box_message_from').val() == '') {
            $('#gift_box_message_from').addClass('is-invalid');
            errors = true;
        }
        if ($('#gift_box_message_to').val() == '') {
            $('#gift_box_message_to').addClass('is-invalid');
            errors = true;
        }
        if ($('#gift_box_message_message').val() == '') {
            $('#gift_box_message_message').addClass('is-invalid');
            errors = true;
        }

        if (errors) {
            return false;
        }

        _this.isLoading = true;

        var values = '_token=' + $("meta[name='csrf-token']").attr("content");;
        values += '&from=' + $('#gift_box_message_from').val();
        values += '&to=' + $('#gift_box_message_to').val();
        values += '&message=' + $('#gift_box_message_message').val();
		$.ajax({
            type: "POST",
            url: baseURL + "/gift-box/add-message",
            data: values,
            success: function(response) {
				_this.isLoading = false;

                if (response.status == 0) {
                    for(var errorKey in response.errors) {
                        if(!response.errors.hasOwnProperty(errorKey)) continue;
                        for(var error in response.errors[errorKey]) {
                            $('#gift_box_message_' + errorKey).addClass('is-invalid');
                        }
                    }
                    return false;
                }

                if (response.status == 1) {

                    window.location = url;

                    $('#mobile-gift-box-cart-container').html(response.mobile_view);
					$('#gift-box-cart-container').html(response.view);
                    const ps = new
                        PerfectScrollbar('.scroll-box', {
                        wheelSpeed: 2,
                        // wheelPropagation: true,
                        minScrollbarLength: 20,
                        // maxScrollbarLength: 63,
                        useBothWheelAxes: true
                    });

					return;
                }

				Swal.fire({
					width: "350px",
					//icon: "success",
					title: "Error!",
					html: response.message
				});
            },
            error(error) {
				_this.isLoading = false;
            }
        });
    },
    changeQty(event) {
        const _this = event.data;
        var element = this;
        var id = $(this).data('id');

        if (_this.isLoading) { return false; }

        _this.isLoading = true;

        var qty = $('#gift-box-cart-qty-' + id + ' option:selected').val();
        if ($(this).data('type') == 'mobile') {
            qty = $(this).data('qty');
        }

        var values = '_token=' + $("meta[name='csrf-token']").attr("content");;
        values += '&id=' + id;
        values += '&qty=' + qty;
		$.ajax({
            type: "POST",
            url: baseURL + "/gift-box/update-qty",
            data: values,
            success: function(response) {
				_this.isLoading = false;

                if (response.status == 1) {

                    $('#mobile-gift-box-cart-container').html(response.mobile_view);
					$('#gift-box-cart-container').html(response.view);
                    const ps = new
                        PerfectScrollbar('.scroll-box', {
                        wheelSpeed: 2,
                        // wheelPropagation: true,
                        minScrollbarLength: 20,
                        // maxScrollbarLength: 63,
                        useBothWheelAxes: true
                    });

					return;
                }

				Swal.fire({
					width: "350px",
					//icon: "success",
					title: "Error!",
					html: response.message
				});
            },
            error(error) {
				_this.isLoading = false;
            }
        });
    },
    removeFromBox(event) {
        const _this = event.data;
        var element = this;
        var id = $(this).data('id');

        if (_this.isLoading) { return false; }

        _this.isLoading = true;

        var values = '_token=' + $("meta[name='csrf-token']").attr("content");;
        values += '&id=' + id;
		$.ajax({
            type: "POST",
            url: baseURL + "/gift-box/remove-from-box",
            data: values,
            success: function(response) {
				_this.isLoading = false;

                if (response.status == 1) {

					$('#mobile-gift-box-cart-container').html(response.mobile_view);
					$('#gift-box-cart-container').html(response.view);
                    const ps = new
                        PerfectScrollbar('.scroll-box', {
                        wheelSpeed: 2,
                        // wheelPropagation: true,
                        minScrollbarLength: 20,
                        // maxScrollbarLength: 63,
                        useBothWheelAxes: true
                    });

					return;
                }

				Swal.fire({
					width: "350px",
					//icon: "success",
					title: "Error!",
					html: response.message
				});
            },
            error(error) {
				_this.isLoading = false;
            }
        });
    },
    addToBox(event) {
        const _this = event.data;
        var element = this;
        var id = $(this).data('id');

        if (_this.isLoading) { return false; }
        
        _this.isLoading = true;
		$(element).find('i').show();

        var values = '_token=' + $("meta[name='csrf-token']").attr("content");;
        values += '&id=' + id;
		$.ajax({
            type: "POST",
            url: baseURL + "/gift-box/add-to-box",
            data: values,
            success: function(response) {
				_this.isLoading = false;
				$(element).find('i').hide();

                if (response.status == 1) {

					$(element).find('span').text($(element).data('in-cart-text'));
                    $('#mobile-gift-box-cart-container').html(response.mobile_view);
                    $('#gift-box-cart-container').html(response.view);
                    const ps = new
                        PerfectScrollbar('.scroll-box', {
                        wheelSpeed: 2,
                        // wheelPropagation: true,
                        minScrollbarLength: 20,
                        // maxScrollbarLength: 63,
                        useBothWheelAxes: true
                    });

					return;
                }

				Swal.fire({
					width: "350px",
					//icon: "success",
					title: "Error!",
					html: response.message
				});
            },
            error(error) {
				_this.isLoading = false;
				$(element).find('i').hide();
            }
        });
    },
    category(event) {
        const _this = event.data;
        let url = $(this).data('url');

        let query = _this.getSelectedFiltersFromUrl(['c', 'page']);
        if ($('#category option:selected').val() != '') {
            if (query == '') {
                query += '?c=' + $('#category option:selected').val();
            } else {
                query += '&c=' + $('#category option:selected').val();
            }
        }

        window.location = url + query;
    },
    sort(event) {
        const _this = event.data;
        let url = $(this).data('url');

        let query = _this.getSelectedFiltersFromUrl(['sort']);
        if ($('#sort option:selected').val() != '') {
            if (query == '') {
                query += '?sort=' + $('#sort option:selected').val();
            } else {
                query += '&sort=' + $('#sort option:selected').val();
            }
        }

        window.location = url + query;
    },
    getSelectedFiltersFromUrl(exclude = []) {
        var query = '';

        var data = QueryString(null);
        for (var key of Object.keys(data)) {
            if (key != '') {
                if (exclude.indexOf(key) == -1) {
                    if (query != '') {
                        query += '&' + key + '=' + data[key];
                    } else {
                        query += '?' + key + '=' + data[key];
                    }
                }
            }
        }

        return query;
    }
}

$(document).ready(function() {
    if ($('.gift-boxes-module').length > 0) {
        giftBoxesModule.init();
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/modules/gift-boxes.js